export class SEFSaldoFinanceiroModel {

    constructor(
        public cdCentrus?: string,
        public dsRegulamento?: string,
        public dtSlado?: string,
        public vlSaldoDevedor?: number,
        public vlPrestAtraso?: number,
        public vlSaldoTotal?: number,
        public dsOcorrencia?: string,
        public vlPrincPrest?: number,
        public vlJurosPrest?: number,
        public vlSeguroPrest?: number,
        public vlTxAdmPrest?: number,
        public vlUltPrest?: number,
        public nrUltPrest?: string,
        public tpVersao?: string,
        public nrPrazo?: string,
        public cdRegulamento?: string,
        public tpVersaoSef?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/sef-saldo-financeiro.model.ts